import { Leaf } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

const Marquee = () => (
  <div className="overflow-hidden border-y border-sand bg-beige py-5" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee gap-0 hover:[animation-play-state:paused]">
      {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-8 pr-8 whitespace-nowrap">
          <span className="font-serif text-xl sm:text-2xl italic text-taupe">{item}</span>
          <Leaf size={14} className="text-sage/50 shrink-0" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
